<template>

	<div class="portlet box green" v-if="classLevel === 'Bercario' || classLevel === 'Infantil'">

		<div class="portlet-title">
			<div class="caption">
				<i class="fa fa-bath" aria-hidden="true"></i>
				Banhos
			</div>
		</div>

		<div class="portlet-body">
			<label>Quantos banhos o aluno tomou hoje?</label>
			<input type="number" min="1" max="99" placeholder="Exemplo: 1" class="form-control" :value="bathsQuantity" @change="putAgendaBathQuantity">
		</div>

	</div>

</template>

<script>
	import StudentBathQuantity from './student-bath-quantity';
	export default StudentBathQuantity;
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// StudentBathQuantity.vue?2732bb54